<template>
  <div elevation="0" outlined class="mt-2">
    <!-- <div class="px-6 pt-5 pb-3 d-flex align-center flex-wrap" style="gap: 12px;">
      <v-btn color="primary" outlined elevation="0" small v-allowed="'edit_schedule'" @click="showAddClassParams()">
        {{ $t('message.add_class') }}
      </v-btn>
    </div> -->


    <div v-if="!loadingSchedule && hasClasses" class="px-0 pb-2">
      <div class="px-2 py-2 d-flex align-center flex-wrap" style="gap:8px;">
        <v-btn v-if="!bulkSelectMode" small outlined color="primary" elevation="0" v-allowed="'edit_schedule'"
          @click="startBulkSelect">
          <v-icon small left>mdi-checkbox-multiple-marked-outline</v-icon>
          Bulk Edit
        </v-btn>
        <template v-else>
          <v-btn small text @click="cancelBulkSelect">{{ $t('message.cancel') }}</v-btn>
          <v-btn small outlined elevation="0" @click="selectAll">Select All</v-btn>
          <v-btn small color="primary" elevation="0" :disabled="selectedClassIds.length === 0"
            @click="openBulkEditDialog">
            <v-icon small left>mdi-square-edit-outline</v-icon>
            Edit ({{ selectedClassIds.length }})
          </v-btn>
        </template>
      </div>
      <v-expansion-panels v-model="scheduleDayPanel" flat class="academy-schedule-panels transparent">
        <v-expansion-panel elevation="0" v-for="d in daysWithClasses" :key="'day-panel-' + d" :class="[
          'academy-schedule-day-panel'
        ]">
          <v-expansion-panel-header class="font-roboto plusGreyDarken2--text text-subtitle-1 font-weight-regular">
            <div class="header_list">
              {{ dayTextFor(d) }} ({{ schedule[d].length }})
            </div>

          </v-expansion-panel-header>
          <v-expansion-panel-content class="pa-0">
            <ScheduleClassRow v-for="(c, hourIndex) in schedule[d]" :key="(c._id || '') + d + hourIndex" :class-data="c"
              :title="c.name" :day-text="dayTextFor(d)" :time-text="formatTimeRange(c)"
              :instructor-line="instructorLineFor(c)" :instructor-image="instructorImageFor(c)"
              :pricing-label="pricingLabelFor(c)"
              :participants-text="participantsTextFor(c)" :membership-label="membershipLabelFor(c)"
              :location-text="c.location || ''" :is-last="isLastClassRow(d, hourIndex)"
              :selectable="bulkSelectMode" :selected="selectedClassIds.includes(c._id)"
              @edit="editFromSchedule" @delete="onDeleteClass" @toggle-select="toggleSelectClass" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div v-else-if="loadingSchedule" class="pa-4">
      <v-skeleton-loader type="card" />
    </div>
    <div v-else class="pa-6">
      <div class="text-subtitle-1">{{ $t('message.schedule_explain1') }}</div>
      {{ $t('message.schedule_explain2') }} {{ $t('message.academies') }} {{ $t('message.schedule_explain3') }}
    </div>

    <v-dialog v-model="bulkEditDialog" width="90%">
      <v-card outlined>
        <v-card-actions>
          <h2>
            <v-icon left color="primary">mdi-square-edit-outline</v-icon>
            Editing {{ selectedClassIds.length }} {{ selectedClassIds.length === 1 ? $t('message.class') : $t('message.classes') || 'classes' }}
          </h2>
        </v-card-actions>
        <v-card-text>
          <v-row v-if="members && members.length > 0">
            <v-col cols="12">
              <v-autocomplete hide-details v-model="bulkEdit.professorUser" :items="members"
                :label="$t('message.professor') + ' (' + $t('message.optional') + ')'" item-text="text"
                item-value="value" clearable outlined dense />
            </v-col>
          </v-row>
          <v-row v-if="members && members.length > 0">
            <v-col cols="12">
              <v-autocomplete multiple small-chips hide-details v-model="bulkEdit.assistantProfessors" :items="members"
                :label="$t('message.assistant_professors') + ' (' + $t('message.optional') + ')'" item-text="text"
                item-value="value" clearable outlined dense />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="mb-0 pb-0">
              <v-textarea hide-details outlined dense v-model="bulkEdit.details"
                :label="$t('message.details') + ' (' + $t('message.optional') + ')'" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-combobox hide-details outlined dense v-model="bulkEditLocation" :search-input.sync="bulkLocationInput"
                :items="availableLocations" :label="$t('message.location') + ' (' + $t('message.optional') + ')'"
                clearable />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-list dense>
                <v-list-item>
                  <v-list-item-action>
                    <v-switch dense hide-details v-model="bulkOverrideAcceptVisitors" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('message.accept_visitors') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ $t('message.accept_visitors_explained') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="bulkOverrideAcceptVisitors" class="ml-8">
                  <v-list-item-action>
                    <v-switch dense hide-details v-model="bulkEdit.acceptVisitors" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ bulkEdit.acceptVisitors ? $t('message.enabled') : $t('message.disabled') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <template v-if="bulkOverrideAcceptVisitors && bulkEdit.acceptVisitors">
                  <v-list-item class="ml-8">
                    <v-list-item-content>
                      <v-text-field hide-details outlined dense type="number" v-model="bulkEdit.maxTrialAttendance"
                        :label="$t('message.max_trial_attendance') + ' (' + $t('message.optional') + ')'" />
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="ml-8">
                    <v-list-item-action>
                      <v-switch dense hide-details v-model="bulkEdit.disableSameDayTrial" />
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('message.disable_same_day_trial') }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-list-item>
                  <v-list-item-action>
                    <v-switch dense hide-details v-model="bulkOverrideFree" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('message.free') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ $t('message.free_class_explained') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="bulkOverrideFree" class="ml-8">
                  <v-list-item-action>
                    <v-switch dense hide-details v-model="bulkEdit.free" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ bulkEdit.free ? $t('message.enabled') : $t('message.disabled') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-switch dense hide-details v-model="bulkRequireRegistration" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('message.require_registration') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ $t('message.require_registration_explained') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <div v-if="bulkRequireRegistration">
                <v-text-field hide-details outlined dense v-model="bulkEdit.maxCapacity"
                  :label="$t('message.max_capacity')" />
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-list dense>
                <v-list-item>
                  <v-list-item-action>
                    <v-switch dense hide-details v-model="bulkShowColorPicker" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('message.class_color') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ $t('message.class_color_explained') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-color-picker v-if="bulkShowColorPicker" v-model="bulkEdit.color" class="ml-12" dot-size="25"
                hide-mode-switch hide-inputs mode="hexa" show-swatches swatches-max-height="150" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="processing" small color="primary" outlined elevation="0" @click="bulkUpdateInSchedule">
            <v-icon small left>mdi-square-edit-outline</v-icon>{{ $t('message.update') }}
          </v-btn>
          <v-btn small elevation="0" class="outlined-btn" @click="bulkEditDialog = false">
            {{ $t('message.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editClassDialog" width="90%">
      <v-card outlined>
        <v-card-actions>
          <h2>{{ $t('message.class') }}</h2>
        </v-card-actions>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="5">
              <v-text-field hide-details outlined dense :label="$t('message.class_title')" v-model="newClass.name" />
            </v-col>
            <v-col cols="12" sm="3">
              <v-select hide-details dense v-if="addingClass" :items="daysSelector" item-text="text" item-value="value"
                :label="$t('message.class_day')" v-model="newClass.day" outlined multiple />
              <v-select hide-details :disabled="true" dense v-else :items="daysSelector" item-text="text"
                item-value="value" :label="$t('message.class_day')" v-model="newClass.day" outlined />
            </v-col>
            <v-col cols="12" sm="2">
              <v-select hide-details dense :items="hours" v-model="newClass.start" item-text="display"
                item-value="value" :label="$t('message.class_start')" outlined />
            </v-col>
            <v-col cols="12" sm="2">
              <v-select hide-details dense :items="hours" v-model="newClass.end" item-text="display" item-value="value"
                :label="$t('message.class_end')" outlined />
            </v-col>
          </v-row>
          <v-row v-if="members && members.length > 0">
            <v-col cols="12">
              <v-autocomplete hide-details v-model="newClass.professorUser" :items="members"
                :label="$t('message.professor') + ' (' + $t('message.optional') + ')'" item-text="text"
                item-value="value" clearable outlined dense />
            </v-col>
          </v-row>
          <v-row v-if="members && members.length > 0">
            <v-col cols="12">
              <v-autocomplete multiple small-chips hide-details v-model="newClass.assistantProfessors" :items="members"
                :label="$t('message.assistant_professors') + ' (' + $t('message.optional') + ')'" item-text="text"
                item-value="value" clearable outlined dense />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="mb-0 pb-0">
              <v-textarea hide-details outlined dense v-model="newClass.details"
                :label="$t('message.details') + ' (' + $t('message.optional') + ')'" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-combobox hide-details outlined dense v-model="newClassLocation" :search-input.sync="locationInput"
                :items="availableLocations" :label="$t('message.location') + ' (' + $t('message.optional') + ')'"
                clearable />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-list dense>
                <v-list-item>
                  <v-list-item-action>
                    <v-switch dense hide-details v-model="newClass.acceptVisitors" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t('message.accept_visitors') }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t('message.accept_visitors_explained') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <template v-if="newClass.acceptVisitors">
                  <v-list-item class="ml-8">
                    <v-list-item-content>
                      <v-text-field hide-details outlined dense type="number" v-model="newClass.maxTrialAttendance"
                        :label="$t('message.max_trial_attendance') + ' (' + $t('message.optional') + ')'" />
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="ml-8">
                    <v-list-item-action>
                      <v-switch dense hide-details v-model="newClass.disableSameDayTrial" />
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('message.disable_same_day_trial') }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-list-item>
                  <v-list-item-action>
                    <v-switch dense hide-details v-model="newClass.free" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t('message.free') }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t('message.free_class_explained') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-switch dense hide-details v-model="requireRegistration" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t('message.require_registration') }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t('message.require_registration_explained') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <div v-if="requireRegistration">
                <v-text-field hide-details outlined dense v-model="newClass.maxCapacity"
                  :label="$t('message.max_capacity')" />
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-list dense>
                <v-list-item>
                  <v-list-item-action>
                    <v-switch dense hide-details v-model="showColorPicker" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('message.class_color') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ $t('message.class_color_explained') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-color-picker v-if="showColorPicker" v-model="newClass.color" class="ml-12" dot-size="25"
                hide-mode-switch hide-inputs mode="hexa" show-swatches swatches-max-height="150" />
            </v-col>
          </v-row>
          <div v-if="error" class="error--text">{{ $t('message.fill_all_params') }}</div>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="processing" outlined v-if="!editingClass" small color="primary" elevation="0"
            @click="addToSchedule()">
            <v-icon>mdi-plus-circle-outline</v-icon> {{ $t('message.add') }}
          </v-btn>
          <v-btn :loading="processing" v-else small outlined color="primary" elevation="0" @click="updateInSchedule()">
            <v-icon>mdi-square-edit-outline</v-icon>{{ $t('message.update') }}
          </v-btn>
          <v-btn small elevation="0" class="outlined-btn" @click="showAddClassParams(true)">
            {{ $t('message.close') }}
          </v-btn>
        </v-card-actions>
        <div class="text-caption pl-2">
          {{ $t('message.only_editing_one_class') }}
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/services/Api';
import ScheduleClassRow from './ScheduleClassRow.vue';

export default {
  name: 'AcademyScheduleList',
  components: {
    ScheduleClassRow
  },
  props: {
    value: null
  },
  data() {
    return {
      newClass: {},
      schedule: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: []
      },
      loadingSchedule: false,
      /** @type {{ value: string, text: string, image: string | null }[]} */
      members: [],
      hasClasses: false,
      updateMessage: null,
      selectedClassUsage: null,
      error: false,
      restrictedClasses: [],
      restrictedClassesUsage: {},
      addingClass: false,
      editingClass: false,
      processing: false,
      requireRegistration: false,
      showColorPicker: false,
      editClassDialog: null,
      locationInput: null,
      newClassLocation: null,
      bulkSelectMode: false,
      /** @type {string[]} */
      selectedClassIds: [],
      bulkEditDialog: false,
      bulkEdit: {},
      bulkRequireRegistration: false,
      bulkShowColorPicker: false,
      bulkOverrideAcceptVisitors: false,
      bulkOverrideFree: false,
      bulkEditLocation: null,
      bulkLocationInput: null,
      scheduleDayPanel: 0,
      days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      daysSelector: [
        { text: this.$t('message.monday'), value: 'monday' },
        { text: this.$t('message.tuesday'), value: 'tuesday' },
        { text: this.$t('message.wednesday'), value: 'wednesday' },
        { text: this.$t('message.thursday'), value: 'thursday' },
        { text: this.$t('message.friday'), value: 'friday' },
        { text: this.$t('message.saturday'), value: 'saturday' },
        { text: this.$t('message.sunday'), value: 'sunday' }
      ],
      hours: this.initializeHours()
    };
  },
  created() {
    this.scheduleTemplate = [];
    Api()
      .get('admins/academy/' + this.$store.state.selectedAcademy + '/members')
      .then((response) => {
        const data = response.data;
        if (data) {
          for (const m of data.approved) {
            this.members.push({ value: m._id, text: m.fName + ' ' + m.lName, image: m.userImageSmall || null });
          }
        }
      });
    this.loadSchedule();
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {
    daysWithClasses() {
      return this.days.filter((d) => this.schedule[d] && this.schedule[d].length > 0);
    },
    availableLocations() {
      const locations = new Set();
      /** @type {[string, any[]][]} */
      const entries = Object.entries(this.schedule);
      for (const [, classes] of entries) {
        for (const c of classes) {
          if (c && c.location) locations.add(c.location);
        }
      }
      return Array.from(locations).sort();
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.schedule = newValue;
      }
    },
    bulkOverrideAcceptVisitors(val) {
      if (val) this.bulkEdit.acceptVisitors = true;
    },
    bulkOverrideFree(val) {
      if (val) this.bulkEdit.free = true;
    },
    locationInput(val) {
      if (!val) return;
      const sanitized = val.replace(/[^a-zA-Z0-9\s\-.,'/()#À-ÖØ-öø-ÿ]/g, '');
      if (sanitized !== val) {
        this.newClassLocation = sanitized;
        this.locationInput = sanitized;
      }
    },
    'daysWithClasses.length'(len) {
      this.$nextTick(() => {
        const max = Math.max(0, len - 1);
        if (typeof this.scheduleDayPanel === 'number' && this.scheduleDayPanel > max) {
          this.scheduleDayPanel = max;
        }
      });
    }
  },
  methods: {
    dayTextFor(dayKey) {
      const map = {
        monday: this.$t('message.monday'),
        tuesday: this.$t('message.tuesday'),
        wednesday: this.$t('message.wednesday'),
        thursday: this.$t('message.thursday'),
        friday: this.$t('message.friday'),
        saturday: this.$t('message.saturday'),
        sunday: this.$t('message.sunday')
      };
      return map[dayKey] || dayKey;
    },
    formatTimeRange(c) {
      return (
        this.$d(this.numberToDate(c.start), 'time', this.$i18n.locale) +
        ' - ' +
        this.$d(this.numberToDate(c.end), 'time', this.$i18n.locale)
      );
    },
    /** @param {any} c */
    instructorImageFor(c) {
      if (c.professorUser && this.members.length > 0) {
        const member = this.members.find((m) => m.value == c.professorUser);
        return member ? member.image : null;
      }
      return null;
    },
    instructorLineFor(c) {
      if (c.professorUser && this.members.length > 0) {
        const name = this.getProfessorName(c.professorUser);
        const extra =
          c.assistantProfessors && c.assistantProfessors.length
            ? ' (+' + c.assistantProfessors.length + ' ' + this.$t('message.more') + ')'
            : '';
        if (!name) return '—';
        return name + extra;
      }
      return '—';
    },
    pricingLabelFor(c) {
      return c.free ? this.$t('message.free') : this.$t('message.paid');
    },
    participantsTextFor(c) {
      const parts = [];
      if (c.details) {
        parts.push(this.$t('message.has_details'));
      }
      if (c.maxCapacity > 0) {
        parts.push(this.$t('message.max_capacity') + ': ' + c.maxCapacity);
      }
      if (parts.length === 0) {
        return '—';
      }
      return parts.join(' · ');
    },
    membershipLabelFor(c) {
      return c.acceptVisitors ? this.$t('message.accepting_visitors') : this.$t('message.members_only');
    },
    isLastClassRow(dayKey, hourIndex) {
      if (this.daysWithClasses.length === 0) return true;
      const lastDay = this.daysWithClasses[this.daysWithClasses.length - 1];
      if (dayKey !== lastDay) return false;
      const list = this.schedule[dayKey] || [];
      return hourIndex === list.length - 1;
    },
    onDeleteClass(classData) {
      if (classData && classData._id) {
        this.removeFromSchedule(classData._id);
      }
    },
    checkScheduleIds() {
      let fixSchedule = false;
      const days = Object.keys(this.schedule);
      if (days && days.length > 0) {
        for (const day of days) {
          const dayClasses = this.schedule[day];
          if (!dayClasses) continue;
          for (const c of dayClasses) {
            if (!c._id) fixSchedule = true;
            break;
          }
        }
      }
      if (fixSchedule) {
        console.log('We need to fix');
        this.updateSchedule(true);
      }
      return fixSchedule;
    },
    isRestricted(id) {
      if (this.restrictedClasses.indexOf(id) < 0) return false;
      return true;
    },
    loadSchedule() {
      this.loadingSchedule = true;
      Api()
        .get('admins/academy/' + this.$store.state.managedAcademy + '/schedule')
        .then((response) => {
          const data = response.data;
          if (data) {
            this.schedule = data.schedule;
            this.restrictedClasses = data.restricted;
            this.restrictedClassesUsage = data.usage;
            this.hasClasses = this.days.some((d) => this.schedule[d] && this.schedule[d].length > 0);
            const needsFixing = this.checkScheduleIds();
            if (needsFixing) {
              const vm = this;
              setTimeout(function () {
                vm.loadSchedule();
              }, 1000);
            } else {
              this.loadingSchedule = false;
            }
          } else {
            this.loadingSchedule = false;
          }
        })
        .catch(() => {
          this.loadingSchedule = false;
        });
    },
    getProfessorName(id) {
      if (this.members) {
        for (const m of this.members) {
          if (m.value == id) return m.text;
        }
      }
    },
    initializeHours() {
      const hours = [];
      for (let totalMinutes = 5 * 60; totalMinutes < 24 * 60; totalMinutes += 5) {
        const h = Math.floor(totalMinutes / 60);
        const m = totalMinutes % 60;
        const display = `${h}:${String(m).padStart(2, '0')}`;
        const value = parseFloat(`${h}.${String(m).padStart(2, '0')}`);
        hours.push({ display: display, value: value });
      }
      return hours;
    },
    numberToString(time) {
      const fixed = parseFloat(time).toFixed(2);
      const [h, m] = fixed.split('.');
      return `${h}:${m || '00'}`;
    },
    showAddClassParams(clear) {
      this.editingClass = false;
      this.newClass = {};
      this.newClass.name = null;
      this.newClass.day = null;
      this.newClass.start = null;
      this.newClass.end = null;
      this.newClass.details = null;
      this.newClass.color = null;
      this.newClassLocation = null;
      this.locationInput = null;
      this.requireRegistration = false;
      this.showColorPicker = false;
      if (clear) {
        this.editClassDialog = false;
      } else {
        this.editClassDialog = true;
        this.addingClass = true;
      }
    },
    addToSchedule() {
      this.error = false;
      if (!this.newClass.name || !this.newClass.day || !this.newClass.start || !this.newClass.end) {
        this.error = true;
        return;
      }
      if (Array.isArray(this.newClass.day)) {
        for (const day of this.newClass.day) {
          let dayClasses = this.schedule[day];
          if (!dayClasses) dayClasses = [];
          dayClasses.push({
            name: this.newClass.name,
            day: day,
            start: this.newClass.start,
            end: this.newClass.end,
            professorUser: this.newClass.professorUser,
            assistantProfessors: this.newClass.assistantProfessors,
            details: this.newClass.details,
            acceptVisitors: this.newClass.acceptVisitors,
            maxTrialAttendance: this.newClass.acceptVisitors && this.newClass.maxTrialAttendance ? Number(this.newClass.maxTrialAttendance) : null,
            disableSameDayTrial: this.newClass.acceptVisitors ? this.newClass.disableSameDayTrial || false : false,
            maxCapacity: this.newClass.maxCapacity,
            free: this.newClass.free,
            color: this.showColorPicker ? this.newClass.color?.hex || this.newClass.color : null,
            location: this.newClassLocation || null
          });
          this.schedule[day] = this.sortedArray(dayClasses);
        }
      } else {
        let dayClasses2 = this.schedule[this.newClass.day];
        if (!dayClasses2) dayClasses2 = [];
        dayClasses2.push({
          name: this.newClass.name,
          day: this.newClass.day,
          start: this.newClass.start,
          end: this.newClass.end,
          professorUser: this.newClass.professorUser,
          assistantProfessors: this.newClass.assistantProfessors,
          details: this.newClass.details,
          acceptVisitors: this.newClass.acceptVisitors,
          maxTrialAttendance: this.newClass.acceptVisitors && this.newClass.maxTrialAttendance ? Number(this.newClass.maxTrialAttendance) : null,
          disableSameDayTrial: this.newClass.acceptVisitors ? this.newClass.disableSameDayTrial || false : false,
          maxCapacity: this.newClass.maxCapacity,
          free: this.newClass.free,
          color: this.showColorPicker ? this.newClass.color?.hex || this.newClass.color : null,
          location: this.newClass.location || null
        });
        this.schedule[this.newClass.day] = this.sortedArray(dayClasses2);
      }
      this.$emit('input', this.schedule);
      this.newClass = {};
      this.addingClass = false;
      this.hasClasses = true;
      this.updateSchedule();
    },
    updateInSchedule() {
      this.error = false;
      const classData = this.newClass;
      if (!this.newClass.name || !this.newClass.day || !this.newClass.start || !this.newClass.end) {
        this.error = true;
        return;
      }
      const dayClasses = this.schedule[classData.day];
      for (const c of dayClasses) {
        if (c._id == classData._id) {
          c.professorUser = classData.professorUser;
          c.assistantProfessors = classData.assistantProfessors;
          c.acceptVisitors = classData.acceptVisitors;
          c.maxTrialAttendance = classData.acceptVisitors && classData.maxTrialAttendance ? Number(classData.maxTrialAttendance) : null;
          c.disableSameDayTrial = classData.acceptVisitors ? classData.disableSameDayTrial || false : false;
          c.details = classData.details;
          c.start = classData.start;
          c.end = classData.end;
          c.name = classData.name;
          c.maxCapacity = classData.maxCapacity;
          c.free = classData.free;
          c.color = this.showColorPicker ? classData.color?.hex || classData.color : null;
          c.location = this.newClassLocation || null;
          if (!this.requireRegistration) c.maxCapacity = null;
          break;
        }
      }
      this.$emit('input', this.schedule);
      this.newClass = {};
      this.addingClass = false;
      this.hasClasses = true;
      this.editClassDialog = false;
      this.updateSchedule();
    },
    editFromSchedule(classData) {
      try {
        this.addingClass = false;
        this.newClass = {};
        this.newClass.name = classData.name;
        this.newClass.day = classData.day;
        this.newClass.start = classData.start;
        this.newClass.end = classData.end;
        this.newClass._id = classData._id;
        this.newClass.professorUser = classData.professorUser;
        this.newClass.assistantProfessors = classData.assistantProfessors;
        this.newClass.details = classData.details;
        this.newClass.acceptVisitors = classData.acceptVisitors;
        this.newClass.maxTrialAttendance = classData.maxTrialAttendance || null;
        this.newClass.disableSameDayTrial = classData.disableSameDayTrial || false;
        this.newClass.maxCapacity = classData.maxCapacity;
        this.newClass.free = classData.free;
        this.newClass.color = classData.color;
        this.newClassLocation = classData.location || null;
        this.locationInput = classData.location || null;
        if (classData.maxCapacity) this.requireRegistration = true;
        this.showColorPicker = !!classData.color;
        this.editingClass = true;
        this.editClassDialog = true;
      } catch (e) {
        if (e) console.log(e);
      }
    },
    removeFromSchedule(id) {
      const days = Object.keys(this.schedule);
      let found = false;
      if (days && days.length > 0) {
        for (const day of days) {
          const dayClasses = this.schedule[day];
          if (!dayClasses) continue;
          let index = 0;
          for (const c of dayClasses) {
            if (c._id == id) {
              dayClasses.splice(index, 1);
              found = true;
              break;
            }
            index++;
          }
        }
      }
      if (found) {
        this.hasClasses = this.days.some((d) => this.schedule[d] && this.schedule[d].length > 0);
        Api()
          .delete('admins/academy/' + this.$store.state.managedAcademy + '/schedule/' + id)
          .then(() => {
            this.showAlert('success', this.$t('message.updated'));
          })
          .catch((e) => {
            if (e) this.showAlert('error', 'Oops!', this.$t('message.error_generic'));
          });
      }
    },
    startBulkSelect() {
      this.bulkSelectMode = true;
      this.selectedClassIds = [];
    },
    cancelBulkSelect() {
      this.bulkSelectMode = false;
      this.selectedClassIds = [];
    },
    selectAll() {
      const ids = [];
      for (const d of this.days) {
        for (const c of (this.schedule[d] || [])) {
          if (c._id) ids.push(c._id);
        }
      }
      this.selectedClassIds = ids;
    },
    /** @param {string} id */
    toggleSelectClass(id) {
      const idx = this.selectedClassIds.indexOf(id);
      if (idx >= 0) {
        this.selectedClassIds.splice(idx, 1);
      } else {
        this.selectedClassIds.push(id);
      }
    },
    openBulkEditDialog() {
      this.bulkEdit = {
        professorUser: null,
        assistantProfessors: [],
        details: null,
        acceptVisitors: false,
        maxTrialAttendance: null,
        disableSameDayTrial: false,
        free: false,
        maxCapacity: null,
        color: null
      };
      this.bulkRequireRegistration = false;
      this.bulkShowColorPicker = false;
      this.bulkOverrideAcceptVisitors = false;
      this.bulkOverrideFree = false;
      this.bulkEditLocation = null;
      this.bulkLocationInput = null;
      this.bulkEditDialog = true;
    },
    bulkUpdateInSchedule() {
      const selectedSet = new Set(this.selectedClassIds);
      for (const d of this.days) {
        const dayClasses = this.schedule[d] || [];
        for (let i = 0; i < dayClasses.length; i++) {
          const c = dayClasses[i];
          if (!c._id || !selectedSet.has(c._id)) continue;
          const updated = { ...c };
          if (this.bulkEdit.professorUser != null) updated.professorUser = this.bulkEdit.professorUser;
          if (this.bulkEdit.assistantProfessors && this.bulkEdit.assistantProfessors.length > 0)
            updated.assistantProfessors = this.bulkEdit.assistantProfessors;
          if (this.bulkEdit.details != null && this.bulkEdit.details !== '') updated.details = this.bulkEdit.details;
          if (this.bulkEditLocation != null) updated.location = this.bulkEditLocation;
          if (this.bulkOverrideAcceptVisitors) {
            updated.acceptVisitors = this.bulkEdit.acceptVisitors;
            if (this.bulkEdit.acceptVisitors) {
              updated.maxTrialAttendance = this.bulkEdit.maxTrialAttendance ? Number(this.bulkEdit.maxTrialAttendance) : null;
              updated.disableSameDayTrial = this.bulkEdit.disableSameDayTrial || false;
            }
          }
          if (this.bulkOverrideFree) updated.free = this.bulkEdit.free;
          if (this.bulkRequireRegistration) updated.maxCapacity = this.bulkEdit.maxCapacity;
          if (this.bulkShowColorPicker) updated.color = this.bulkEdit.color?.hex || this.bulkEdit.color || null;
          this.$set(this.schedule[d], i, updated);
        }
      }
      this.$emit('input', this.schedule);
      this.bulkEditDialog = false;
      this.cancelBulkSelect();
      this.updateSchedule();
    },
    compare(a, b) {
      if (a.start < b.start) return -1;
      if (a.start > b.start) return 1;
      return 0;
    },
    sortedArray(array) {
      if (array) {
        return array.sort(this.compare);
      }
      return array;
    },
    numberToDate(time) {
      const fixed = parseFloat(time).toFixed(2);
      const [h, m] = fixed.split('.');
      const d = new Date();
      d.setHours(parseInt(h, 10));
      d.setMinutes(parseInt(m || '0', 10));
      d.setSeconds(0);
      return d;
    },
    updateSchedule(skipAlert) {
      try {
        this.processing = true;
        const data = [
          {
            propName: 'schedule',
            value: this.schedule
          }
        ];
        Api()
          .patch('admins/academy/' + this.$store.state.selectedAcademy, {
            values: data
          })
          .then((response) => {
            const res = response.data;
            if (res) {
              this.editingClass = false;
              this.editClassDialog = false;
              this.newClass.professorUser = null;
              this.newClass.assistantProfessors = null;
              this.newClass.details = null;
              this.newClass.acceptVisitors = null;
              this.newClass.maxTrialAttendance = null;
              this.newClass.disableSameDayTrial = false;
              this.newClass.maxCapacity = null;
              this.newClass.free = false;
              this.requireRegistration = false;
              this.processing = false;
              if (!skipAlert) this.showAlert('success', this.$t('message.updated'));
              this.loadSchedule();
            }
          })
          .catch((e) => {
            if (e) this.showAlert('error', 'Oops!', this.$t('message.error_generic'));
          });
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style scoped>
.academy-schedule-panels.transparent {
  background: transparent !important;
}

.academy-schedule-panels ::v-deep .v-expansion-panel:not(:last-child) {
  margin-bottom: 12px;
}

.academy-schedule-day-panel {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--grey-lighten-2, #E0E0E0);

}

.academy-schedule-day-header {
  min-height: 52px !important;
  padding: 12px 16px !important;
}

.academy-schedule-panels ::v-deep .v-expansion-panel--active .header_list {
  border-bottom: 1px solid var(--grey-lighten-2, #e0e0e0);
  padding-bottom: 24px !important;
  font-weight: 500;
  font-size: 20px;
}
</style>
